import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { TYPE_ICONS } from "src/utils/constants";

export const getTypeIcon = (type: string, fallbackIcon?: IconDefinition) => {
  return TYPE_ICONS[type as keyof typeof TYPE_ICONS] ?? fallbackIcon;
};
